import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import {
	translationAR,
	translationCKB,
	translationDA,
	translationDE,
	translationEL,
	translationEN,
	translationES,
	translationFA,
	translationFI,
	translationFR,
	translationHI,
	translationHU,
	translationIT,
	translationKU,
	translationMK,
	translationNL,
	translationNO,
	translationPL,
	translationPS,
	translationPT,
	translationRU,
	translationSQ,
	translationSR,
	translationSV,
	translationTH,
	translationTR,
	translationUK,
	translationUR,
	translationVI,
	translationZH,
} from './index';
const resources = {
	en: {translation: translationEN},
	ar: {translation: translationAR},
	ckb: {translation: translationCKB},
	da: {translation: translationDA},
	de: {translation: translationDE},
	el: {translation: translationEL},
	es: {translation: translationES},
	fa: {translation: translationFA},
	fi: {translation: translationFI},
	fr: {translation: translationFR},
	hi: {translation: translationHI},
	hu: {translation: translationHU},
	it: {translation: translationIT},
	ku: {translation: translationKU},
	mk: {translation: translationMK},
	nb: {translation: translationNO},
	nl: {translation: translationNL},
	no: {translation: translationNO},
	pl: {translation: translationPL},
	ps: {translation: translationPS},
	pt: {translation: translationPT},
	ru: {translation: translationRU},
	sq: {translation: translationSQ},
	sr: {translation: translationSR},
	sv: {translation: translationSV},
	th: {translation: translationTH},
	tr: {translation: translationTR},
	uk: {translation: translationUK},
	ur: {translation: translationUR},
	vi: {translation: translationVI},
	zh: {translation: translationZH},
};
export const LOCALE_LOCALSTORAGE_KEY = 'pifa-language';

// Locales with their own prerendered URL (build/<locale>/index.html). Must stay
// in sync with scripts/prerender-locales.js LOCALES keys. "sv" is the default
// served at "/" — the rest live at "/<locale>/".
export const SUPPORTED_URL_LOCALES = ['ar', 'ckb', 'da', 'de', 'el', 'en', 'es', 'fa', 'fi', 'fr', 'hi', 'hu', 'it', 'ku', 'mk', 'nb', 'nl', 'pl', 'ps', 'pt', 'ru', 'sq', 'sr', 'th', 'tr', 'uk', 'ur', 'vi', 'zh'];
export const URL_DEFAULT_LOCALE = 'sv';
i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources,
		fallbackLng: 'sv',
		keySeparator: '.',
		interpolation: {
			escapeValue: false,
		},
	});

export default i18n;
